import axios from 'axios';
import {COMPANY_API_URL, PROPERTY_API_URL, USER_API_URL,CLERK_API_URL} from "../constants/api_routes";
import {BASE_URL} from "../constants/app_routes";

var headers;

export const updateHeaders = () => {
    let authHeaders = JSON.parse(localStorage.getItem('authentication_headers'));
    let currentUser = JSON.parse(localStorage.getItem('user'));

    headers = {
        'Content-Type': 'application/json',
        'access-token': authHeaders['access-token'],
        'Uid': currentUser.uid,
        'Client': authHeaders.client,
    };
};

export const getHeader = () => {
    return headers;
};

export const signInWithEmailAndPassword = async (email, password,otp_attempt, history) => {
    try {
        const res = await axios.post(`${USER_API_URL}/login`, {email, password,otp_attempt});
        if (res.data.user !== undefined) {
            localStorage.setItem('user', JSON.stringify(res.data.user));
            localStorage.setItem('authentication_headers', JSON.stringify(res.headers));
            updateHeaders();
            return ({
                success: true,
                token: res.headers['access-token'],
                userRole: res.data.user.role,
                userName: res.data.user.name
            });
        }
        else {
            return ({
                success: false,
                error: res.data.error,
                data: res.data
            });
        }
    } catch (error) {
        return ({
            success: false,
            error: "Something went wrong. Try again.",
        });
    }
};

export const signOut = async () => {
    try {
        if(headers.Uid){
            await axios.post(`${USER_API_URL}/logout`, {}, {headers: headers});
            localStorage.clear();
        }
        return true;
    } catch (e) {
        return false;
    }
};

export const getListingData = async (URL) => {
    try {
        const response = await axios.get(`${URL}/list`, {headers: headers});
        return response.data;
    } catch (e) {
        return {
            message:"Something Went wrong. Try Again",
            status:e.response.status
        };
    }
};

export const getQuickListingData = async (URL,property_address_id) => {
    try {
        const response = await axios.get(`${URL}/quicksearch_address_list?property_address_id=${property_address_id}`, {headers: headers});
        return response.data;
    } catch (e) {
        return {
            message:"Something Went wrong. Try Again",
            status:e.response.status
        };
    }
};

export const create = async (URL, formdata) => {
    try {
        await axios.post(`${URL}/create`, formdata, {headers: headers});
        return {
            success:true,
            responseMessage:"Successfully Created"
        }
    } catch (e) {
        return {
            message:e.response.error,
            status:e.response.status,
            data:{success:false}
        };
    }
};

export const update = async (URL, formdata, id) => {
    try {
        return  await axios.put(`${URL}/${id}`, formdata, {headers: headers});
    } catch (e) {
        return {
            message:"Something Went wrong. Try Again",
            status:e.response.status,
            data:{success:false}
        };
    }
};

export const deleteDetail = async (URL, userId) => {
    try {
        return  await axios.delete(`${URL}/${userId}`, {headers: headers});
    } catch (e) {
        return {
            message:"Something Went wrong. Try Again",
            status:e.response.status
        };
    }
};

export const getCurrentUserProfile = async (URL, profileId) => {
    try {
        const response = await axios.get(`${URL}/${profileId}`, {headers: headers});
        return ({
            success:true,
            profileData:response.data});
    } catch (e) {
        return ({
                success: false,
                statusMessage: "Something Went Wrong. Try again later.",
                status:e.response.status
            });
    }
};

export const getClerkAvailability = async (URL, date) => {
    try {
        const response = await axios.get(`${URL}?date=${date}`, {headers: headers});
        return response.data;

    } catch (e) {
        return {
            message:"Something Went wrong. Try Again",
            status:e.response.status
        };
    }
};

export const getPVClerks = async () => {
    try {
        const response = await axios.get(`${CLERK_API_URL}/pv_clerks`, {headers: headers});
        return response.data;

    } catch (e) {
        return {
            message:"Something Went wrong. Try Again",
            status:e.response.status
        };
    }
};

export const getPVClerkLeaves = async (formData) => {
    try {
        const response = await axios.post(`${CLERK_API_URL}/pv_clerk_leaves`,formData,{headers: headers});
        return response.data;

    } catch (e) {
        return {
            message:"Something Went wrong. Try Again",
            status:e.response.status
        };
    }
};

export const getAgentsOfCompany = async (URL, companyID) => {
    try {
        const response = await axios.get(`${URL}/agents?id=${companyID}`, {headers: headers});
        return response.data;
    } catch (e) {
        return {
            message:"Something Went wrong. Try Again",
            status:e.response.status
        };
    }
};

export const getLeaveList = async (URL, profileId) => {
    try {
        const response = await axios.get(`${URL}/leave_list?clerk_profile_id=${profileId}`,{headers: headers});
        return ({
            success:true,
            leaves: response.data
        });
    } catch (e) {
        return ({
            success:false,
            statusMessage:"Something Went Wrong. Try again later.",
            status:e.response.status
        });
    }
};

export const availLeaveOnDate = async (URL, profileId,formData) => {
    try {
        const response = await axios.post(`${URL}/create`,formData,{headers: headers});
        return ({
            success:true,
            statusMessage: response.data
        });
    } catch (e) {
        return ({
            success:false,
            statusMessage:"Something Went Wrong. Try again later.",
            status:e.response.status
        });
    }
};

export const cancelLeave = async (URL, leaveId) => {
    try {
        const response = await axios.delete(`${URL}/${leaveId}`,{headers: headers});
        return ({
            success:true,
            statusMessage: response.data
        });
    } catch (e) {
        return ({
            success:false,
            statusMessage:e.response.error?e.response.error:"Something Went Wrong. Try again later.",
            status:e.response.status
        });
    }
};


export const updateProfileById = async (URL, profileId,formData) => {
    try {
        await axios.put(`${URL}/${profileId}`,formData,{headers: headers});
        return ({
            success:true,
            statusMessage:"Successfully updated Profile Information!!"
        });
    } catch (e) {
        return ({
            success:false,
            statusMessage:"Something Went Wrong. Try again later.",
            status:e.response.status
        });
    }
};

export const getAddressList = async (URL) => {
    try {
        const response = await axios.get(`${URL}/address_list`,{headers:headers});
        return response.data;
    } catch (e) {
        return [];
    }
};

export const getPropertyDetails = async (id) => {
    try {
        const response = await axios.get(`${PROPERTY_API_URL}/details?id=${id}`,{headers:headers});
        return response.data;
    } catch (e) {
        return [];
    }
};

export const requestPasswordResetLink = async (formData) => {
    try {
        const response = await axios.post(`${BASE_URL}/auth/password`,formData);
        return response.data;
    } catch (e) {
        return {success:false,
        error:e.response.data.errors};
    }
};

export const changeForgottenPassword =  async (formData,header) => {
    try {
        const response = await axios.put(`${BASE_URL}/auth/password`,formData,{headers:header});
        return response.data;
    } catch (e) {
        return {
            success:false,
            error:e.response.data.errors
        };
    }
};

export const updatePassword = async (formData) => {
    try {
        const response = await axios.post(`${USER_API_URL}/change_password`,formData,{headers:headers});
        return response.data;
    } catch(e) {
        return {
            success:false,
            error:e.response.data.error
        }
    }
};

export const updateUserEmail = async (formData) => {
    try {
        const response = await axios.post(`${USER_API_URL}/change_email`,formData,{headers:headers});
        return response.data;
    } catch(e) {
        return {
            success:false,
            error:e.response.data.error,
            status:e.response.status
        }
    }
};

export const uploadCompanyLogo = async (formData) => {
    try {
        const response = await axios.post(`${COMPANY_API_URL}/upload_logo`,formData,{headers:headers});
        return {
            success:true,
            message:"Successfully Uploaded Logo"
        }
    } catch(e){
        return {
            success:false,
            error:e.response.data.error
        }
    }
};

export const mergePropertyWithExistingAddress =  async (formData) => {
    try {
        const response = await axios.post(`${PROPERTY_API_URL}/merge`,formData,{headers:headers});
        return {
            success:true,
            message:"Successfully merged property with existing property address"
        }
    }  catch (e) {
        return {
            success:false,
            error:e.response.data.error?e.response.data.error:"Something went wrong please try again later"
        }
    }
};

export const getAddressesByPincode = async (postcode) => {
    try {
        const response = await axios.get(`${PROPERTY_API_URL}/search?postcode=${postcode}`,{headers:headers});
        return {
            success:true,
            data: response.data,
        }
    } catch (e) {
        return {
            success:false,
            error:e.response.data.error?e.response.data.error:"Something went wrong"
        }
    }
};


// WEBPACK FOOTER //
// ./src/data/user_api.js